/* RESPONSIBLE TEAM: team-standalone */

import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
import { ReactRoute } from 'embercom/lib/react-route';

class RequestLogsRoute extends Route {
  @service declare appService: {
    app: { hasStandalonePlatform: (platform: string) => boolean };
  };
  @service declare router: RouterService;

  async beforeModel() {
    if (!this.appService.app.hasStandalonePlatform('custom_helpdesk')) {
      this.router.transitionTo('apps.app.settings');
      return;
    }
  }

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(RequestLogsRoute);
